"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Simple HTTP interaction module
 */
class BasicHTTP {
    static execBeacon(path, data = null) {
        return new Promise((accept, reject) => {
            try {
                const body = data || {};
                const headers = {
                    type: "application/json"
                };
                const blob = new Blob([JSON.stringify(body)], headers);
                const result = navigator.sendBeacon(path, blob);
                if (result) {
                    return accept({});
                }
                else {
                    return reject(new Error("BasicHTTP.execBeacon() - could not query request"));
                }
            }
            catch (err) {
                return reject(err);
            }
        });
    }
    static exec(protocol, path, data = null) {
        return new Promise((accept, reject) => {
            try {
                const http = new XMLHttpRequest();
                http.open(protocol, path, true);
                http.setRequestHeader("Content-Type", "application/json");
                http.setRequestHeader("Accept", "application/json");
                http.onload = (e) => {
                    if (http.status === 200) {
                        if (http.response) {
                            try {
                                const resp = JSON.parse(http.response);
                                return accept(resp);
                            }
                            catch (_err) { /* silent */ }
                        }
                        return accept({});
                    }
                    else {
                        return reject(e);
                    }
                };
                http.onerror = (e) => {
                    return reject(e);
                };
                http.onprogress = (_e) => {
                    // empty
                };
                http.send(data ? JSON.stringify(data) : null);
            }
            catch (e) {
                return reject(e);
            }
        });
    }
}
exports.default = BasicHTTP;
